export default __webpack_public_path__ + "47e0a5e749ed62d392f896ce48e7ce4e.png";